import {Typography} from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Modal from '@material-ui/core/Modal';
import {WithStyles, withStyles} from '@material-ui/core/styles';
import React, {useEffect} from 'react';
import {WithTranslation, withTranslation} from 'react-i18next';
import {Link as RouterLink} from 'react-router-dom';

import FailedLogo from 'src/Assets/Images/failed.png?width=305&height=523&quality=85&ignore';
import SuccessLogo from 'src/Assets/Images/success.png?width=378&height=500&quality=85&ignore';
import EnumRoutes from 'src/Routes/EnumRoutes';
import {getRoutePathname} from 'src/Routes/getRoutePathname';

import {formSubmitModalStyles} from './FormSubmitModalStyles';

const FormSubmitModal = (props: FormSubmitModalProps) => {
	const [open, setOpen] = React.useState(props.showModal);
	const linkProps = {language: props.i18n.language};
	const handleClose = () => {
		setOpen(false);
		props.onCloseModal(false);
	};

	useEffect(() => {
		setOpen(props.showModal);
	}, [props.showModal]);

	return (
		<Modal className={props.classes.modal} open={open} onClose={handleClose}>
			<div className={props.classes.paper}>
				<div className={props.classes.imageBlock}>
					<img src={props.hasError ? FailedLogo : SuccessLogo} alt="" />
				</div>
				<div className={props.classes.textBlock}>
					<Typography variant={'h2'} className={props.classes.title}>
						{props.t(props.hasError ? 'title-error' : 'title')}
					</Typography>
					<Typography className={props.classes.description}>
						{props.t(props.hasError ? 'description-error' : 'description')}
					</Typography>
					<RouterLink to={getRoutePathname(EnumRoutes.HOME, linkProps)} className={props.classes.backToHomeWrapper}>
						<Button onClick={handleClose} variant="outlined" color="primary" className={props.classes.backToHome}>
							{props.t('back-to-home')}
						</Button>
					</RouterLink>
				</div>
			</div>
		</Modal>
	);
};

type FormSubmitModalOwn = {
	hasError: boolean;
	onCloseModal: (value: boolean) => void;
	showModal: boolean;
};
type FormSubmitModalProps = FormSubmitModalOwn & WithTranslation & WithStyles;

export default withStyles(formSubmitModalStyles)(withTranslation('modal')(FormSubmitModal));
